import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  signupWrapper: {
    textAlign: 'center',
  },
});

export default useStyles;
